import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/Shared/services/common_services/common.service';
import { DataCommunicationService } from 'src/app/Shared/services/data_service/data-communication.service';
import { TranslateService } from '@ngx-translate/core';
import { PlatformLocation } from '@angular/common';
import { paths } from 'src/app/Shared/enums/paths.enum';

@Component({
  selector: 'app-booking-summary',
  templateUrl: './booking-summary.component.html',
  styleUrls: ['./booking-summary.component.css']
})
export class BookingSummaryComponent implements OnInit {

  serviceList = [];
  rentalCarList = [];
  appointmentDate: any;
  customerDetail: any;
  WaitingTime : any ;
  DropTime : any ;
  serviceTotal = 0;
  customerVehicleList: any = [];
  notes: string;
  dealerName: string;
  showMessage = false;
  bookingMonthName: string;
  BrandCode: string;
  PackageData:any;
  kiosk;
  Pickatkiosk;
  dealerImage: any;
  managerName: any;
  euServiceData = [];
  recallFactory: any;
  selectedAccessories: any;
  selectedGiftCards: any = null;
  constructor(
    private commonService: CommonService,
    private dataCommunicationService: DataCommunicationService,
    private translate: TranslateService,
    private locations: PlatformLocation,
  ) {
    locations.onPopState(() => {
       this.commonService.NavigatePage(paths.BOOKAPPOINTMENT, 'Drammen');
        });
   }
  private getLocalData() {
    this.managerName =  this.commonService.getLocalStorageitem('managerName');
    this.BrandCode = this.commonService.getLocalStorageByKey('vehicleData', 'BrandName');
    this.dealerImage = this.commonService.getLocalStorageitem('dealerImage');
    this.WaitingTime = (localStorage.getItem('waitingTime'));
    this.DropTime = (localStorage.getItem('dropTime'));
    this.appointmentDate = this.commonService.getLocalStorage('AppointDate');
    this.appointmentDate =   this.appointmentDate.day + '.' + this.appointmentDate.month  + '.'  +  this.appointmentDate.year;
    this.PackageData = this.commonService.getLocalStorage('PackageServiceListData')
    this.serviceList = this.commonService.getLocalStorage('SelectedService');
    this.rentalCarList = this.commonService.getLocalStorage('RentalCar');
    this.customerDetail = this.commonService.getLocalStorage('customerData');
    this.customerVehicleList = this.commonService.getLocalStorage('vehicleData');
    this.notes = this.commonService.getLocalStorageitem('notes');
    this.dealerName = this.commonService.getLocalStorage('dealername');
    this.euServiceData =  this.commonService.getLocalStorage('SelectedEUService');
    this.kiosk=this.commonService.getLocalStorageitem('kiosk');
    this.recallFactory=this.commonService.getLocalStorageitem('RF')
    this.Pickatkiosk = this.commonService.getLocalStorageitem('PickAtKiosk');
    this.selectedAccessories = this.commonService.getLocalStorage('SelectedAccessories');
    
    if((this.DropTime==undefined||this.DropTime==null) && (this.WaitingTime==undefined || this.WaitingTime==null))
    {
      this.DropTime='07:00'
    }
    if(this.serviceList!=null) {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.serviceList.length; i++) {
      this.serviceTotal =  this.serviceTotal + (!this.commonService.isFreeService(this.BrandCode, this.serviceList[i].groupId) ? this.serviceList[i].LineAmountVat : 0);
    }}
    if(this.PackageData!=null)
    {
      this.serviceTotal=this.serviceTotal+ this.PackageData.TotalPrice;
    }
    if (this.euServiceData != null) {
      for (let i = 0; i < this.euServiceData.length; i++) {
        this.serviceTotal = this.serviceTotal + this.euServiceData[i].LineAmountVat;
      }
    }
    this.selectedGiftCards = this.commonService.getLocalStorage("selectedGiftCards");
    // if (this.notes !== undefined && this.notes !== null && this.notes !== '') {
    //   this.showMessage = true;
    // }
  }

  ngOnInit() {
    this.getLocalData();
  }
  getCSSDynamic() {    
    return this.commonService.getBrandTheme(this.BrandCode.toLocaleLowerCase());

  }
}
